module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 7.1d622ce0.wav";